/**
 * This file is generated by the Angular 2 template compiler.
 * Do not edit.
 */
 /* tslint:disable */

import * as import0 from './content-record.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/element';
import * as import4 from '../shared/notification.service';
import * as import5 from '@angular/core/src/linker/view_utils';
import * as import6 from '@angular/core/src/di/injector';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/change_detection';
import * as import9 from '@angular/core/src/linker/element_ref';
import * as import10 from '../shared/config.service';
import * as import11 from '@angular/common/src/location/location';
import * as import12 from '../shared/intl.service';
import * as import13 from './cart.service';
import * as import14 from '../shared/search.service';
import * as import15 from '../shared/utils.service';
import * as import16 from '../shared/meta.service';
import * as import17 from '../shared/content.service';
import * as import18 from '@angular/router/src/router_state';
import * as import19 from '@angular/router/src/router';
import * as import20 from '@angular/core/src/metadata/view';
import * as import21 from '@angular/core/src/linker/component_factory';
import * as import22 from '../../../node_modules/@angular/common/src/directives/ng_switch.ngfactory';
import * as import23 from '../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import24 from '../shared/intl.pipe';
import * as import25 from '../shared/replace.pipe';
import * as import26 from '../shared/number-format.pipe';
import * as import27 from '../shared/name-resolver.pipe';
import * as import28 from '../shared/date2year.pipe';
import * as import29 from '../shared/join.pipe';
import * as import30 from '../shared/truncate.pipe';
import * as import31 from '@angular/core/src/linker/template_ref';
import * as import32 from '@angular/common/src/directives/ng_switch';
import * as import33 from '@angular/common/src/directives/ng_if';
import * as import34 from '../shared/loading-indicator.ngfactory';
import * as import35 from '../shared/loading-indicator';
import * as import36 from '../../../node_modules/@angular/forms/src/directives/select_control_value_accessor.ngfactory';
import * as import37 from '../../../node_modules/@angular/forms/src/directives/ng_model.ngfactory';
import * as import38 from '../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import39 from '../../../node_modules/@angular/common/src/directives/ng_for.ngfactory';
import * as import40 from '@angular/core/src/change_detection/differs/iterable_differs';
import * as import41 from '@angular/common/src/directives/ng_for';
import * as import42 from '@angular/forms/src/directives/select_control_value_accessor';
import * as import43 from '@angular/forms/src/directives/control_value_accessor';
import * as import44 from '@angular/forms/src/directives/ng_model';
import * as import45 from '@angular/forms/src/directives/ng_control';
import * as import46 from '@angular/forms/src/directives/ng_control_status';
import * as import47 from '@angular/core/src/security';
import * as import48 from '../../../node_modules/@angular/forms/src/directives/select_multiple_control_value_accessor.ngfactory';
import * as import49 from '@angular/forms/src/directives/select_multiple_control_value_accessor';
export class Wrapper_ContentRecordComponent {
  context:import0.ContentRecordComponent;
  changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any,p10:any,p11:any) {
    this.changed = false;
    this.context = new import0.ContentRecordComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9,p10,p11);
  }
  detectChangesInInputProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this.changed;
    this.changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  detectChangesInHostProps(view:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
}
var renderType_ContentRecordComponent_Host:import2.RenderComponentType = (null as any);
class _View_ContentRecordComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _NotificationService_0_4:import4.NotificationService;
  _ContentRecordComponent_0_5:Wrapper_ContentRecordComponent;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent_Host0,renderType_ContentRecordComponent_Host,import7.ViewType.HOST,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.selectOrCreateRenderHostElement(this.renderer,'ng-component',import5.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = viewFactory_ContentRecordComponent0(this.viewUtils,this.injector(0),this._appEl_0);
    this._NotificationService_0_4 = new import4.NotificationService(new import9.ElementRef(this._el_0),this.renderer);
    this._ContentRecordComponent_0_5 = new Wrapper_ContentRecordComponent(this.parentInjector.get(import10.ConfigService),this.parentInjector.get(import11.Location),this.parentInjector.get(import12.IntlService),this._NotificationService_0_4,this.parentInjector.get(import13.CartService),this.parentInjector.get(import14.SearchService),new import9.ElementRef(this._el_0),this.parentInjector.get(import15.UtilsService),this.parentInjector.get(import16.MetaService),this.parentInjector.get(import17.ContentService),this.parentInjector.get(import18.ActivatedRoute),this.parentInjector.get(import19.Router));
    this._appEl_0.initComponent(this._ContentRecordComponent_0_5.context,([] as any[]),compView_0);
    compView_0.create(this._ContentRecordComponent_0_5.context,this.projectableNodes,(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return this._appEl_0;
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import4.NotificationService) && (0 === requestNodeIndex))) { return this._NotificationService_0_4; }
    if (((token === import0.ContentRecordComponent) && (0 === requestNodeIndex))) { return this._ContentRecordComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._ContentRecordComponent_0_5.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    if (!throwOnChange) { this._ContentRecordComponent_0_5.context.ngAfterContentChecked(); }
    this._ContentRecordComponent_0_5.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent_Host0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  if ((renderType_ContentRecordComponent_Host === (null as any))) { (renderType_ContentRecordComponent_Host = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,([] as any[]),{})); }
  return new _View_ContentRecordComponent_Host0(viewUtils,parentInjector,declarationEl);
}
export const ContentRecordComponentNgFactory:import21.ComponentFactory<import0.ContentRecordComponent> = new import21.ComponentFactory<import0.ContentRecordComponent>('ng-component',viewFactory_ContentRecordComponent_Host0,import0.ContentRecordComponent);
const styles_ContentRecordComponent:any[] = ([] as any[]);
var renderType_ContentRecordComponent:import2.RenderComponentType = (null as any);
class _View_ContentRecordComponent0 extends import1.AppView<import0.ContentRecordComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _text_8:any;
  _el_9:any;
  _text_10:any;
  _el_11:any;
  _NgSwitch_11_3:import22.Wrapper_NgSwitch;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _el_15:any;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _anchor_20:any;
  /*private*/ _appEl_20:import3.AppElement;
  _TemplateRef_20_5:any;
  _NgSwitchCase_20_6:import22.Wrapper_NgSwitchCase;
  _text_21:any;
  _text_22:any;
  _anchor_23:any;
  /*private*/ _appEl_23:import3.AppElement;
  _TemplateRef_23_5:any;
  _NgIf_23_6:import23.Wrapper_NgIf;
  _text_24:any;
  _text_25:any;
  _text_26:any;
  _anchor_27:any;
  /*private*/ _appEl_27:import3.AppElement;
  _TemplateRef_27_5:any;
  _NgIf_27_6:import23.Wrapper_NgIf;
  _text_28:any;
  /*private*/ _expr_39:any;
  _pipe_intl_0:import24.IntlPipe;
  _pipe_intl_0_0:any;
  _pipe_replace_1:import25.ReplacePipe;
  _pipe_numberFormat_2:import26.NumberFormat;
  _pipe_nameResolver_3:import27.NameResolverPipe;
  _pipe_toYear_4:import28.Date2YearPipe;
  _pipe_join_5:import29.JoinPipe;
  _pipe_truncate_6:import30.TruncatePipe;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent0,renderType_ContentRecordComponent,import7.ViewType.COMPONENT,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_39 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    const parentRenderNode:any = this.renderer.createViewRoot(this.declarationAppElement.nativeElement);
    this._el_0 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','page-title-pull-top page-title parallax3 parallax-fix'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','opacity-light bg-dark-gray'),(null as any));
    this._text_3 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'id','snackbar'),(null as any));
    this._text_5 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_6 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_7 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._text_8 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    this._el_9 = import5.createRenderElement(this.renderer,parentRenderNode,'section',new import5.InlineArray2(2,'class','section-record'),(null as any));
    this._text_10 = this.renderer.createText(this._el_9,'\n    ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_9,'div',new import5.InlineArray2(2,'class','container'),(null as any));
    this._NgSwitch_11_3 = new import22.Wrapper_NgSwitch();
    this._text_12 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'div',new import5.InlineArray2(2,'class','row btn-back'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n            ',(null as any));
    this._el_15 = import5.createRenderElement(this.renderer,this._el_13,'button',new import5.InlineArray2(2,'class','highlight-button btn btn-very-small no-margin continue-shopping-custom'),(null as any));
    this._text_16 = this.renderer.createText(this._el_15,'',(null as any));
    this._text_17 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_11,'\n\n        ',(null as any));
    this._text_19 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._anchor_20 = this.renderer.createTemplateAnchor(this._el_11,(null as any));
    this._appEl_20 = new import3.AppElement(20,11,this,this._anchor_20);
    this._TemplateRef_20_5 = new import31.TemplateRef_(this._appEl_20,viewFactory_ContentRecordComponent1);
    this._NgSwitchCase_20_6 = new import22.Wrapper_NgSwitchCase(this._appEl_20.vcRef,this._TemplateRef_20_5,this._NgSwitch_11_3.context);
    this._text_21 = this.renderer.createText(this._el_11,'\n        \n        ',(null as any));
    this._text_22 = this.renderer.createText(this._el_11,'\n        ',(null as any));
    this._anchor_23 = this.renderer.createTemplateAnchor(this._el_11,(null as any));
    this._appEl_23 = new import3.AppElement(23,11,this,this._anchor_23);
    this._TemplateRef_23_5 = new import31.TemplateRef_(this._appEl_23,viewFactory_ContentRecordComponent2);
    this._NgIf_23_6 = new import23.Wrapper_NgIf(this._appEl_23.vcRef,this._TemplateRef_23_5);
    this._text_24 = this.renderer.createText(this._el_11,'\n    ',(null as any));
    this._text_25 = this.renderer.createText(this._el_9,'\n',(null as any));
    this._text_26 = this.renderer.createText(parentRenderNode,'\n\n',(null as any));
    this._anchor_27 = this.renderer.createTemplateAnchor(parentRenderNode,(null as any));
    this._appEl_27 = new import3.AppElement(27,(null as any),this,this._anchor_27);
    this._TemplateRef_27_5 = new import31.TemplateRef_(this._appEl_27,viewFactory_ContentRecordComponent14);
    this._NgIf_27_6 = new import23.Wrapper_NgIf(this._appEl_27.vcRef,this._TemplateRef_27_5);
    this._text_28 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_15,'click',this.eventHandler(this._handle_click_15_0.bind(this)));
    this._pipe_intl_0 = new import24.IntlPipe();
    this._pipe_intl_0_0 = import5.pureProxy2(this._pipe_intl_0.transform.bind(this._pipe_intl_0));
    this._pipe_replace_1 = new import25.ReplacePipe();
    this._pipe_numberFormat_2 = new import26.NumberFormat();
    this._pipe_nameResolver_3 = new import27.NameResolverPipe();
    this._pipe_toYear_4 = new import28.Date2YearPipe();
    this._pipe_join_5 = new import29.JoinPipe();
    this._pipe_truncate_6 = new import30.TruncatePipe();
    this.init(([] as any[]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._text_8,
      this._el_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._el_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._anchor_20,
      this._text_21,
      this._text_22,
      this._anchor_23,
      this._text_24,
      this._text_25,
      this._text_26,
      this._anchor_27,
      this._text_28
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (20 === requestNodeIndex))) { return this._TemplateRef_20_5; }
    if (((token === import32.NgSwitchCase) && (20 === requestNodeIndex))) { return this._NgSwitchCase_20_6.context; }
    if (((token === import31.TemplateRef) && (23 === requestNodeIndex))) { return this._TemplateRef_23_5; }
    if (((token === import33.NgIf) && (23 === requestNodeIndex))) { return this._NgIf_23_6.context; }
    if (((token === import32.NgSwitch) && ((11 <= requestNodeIndex) && (requestNodeIndex <= 24)))) { return this._NgSwitch_11_3.context; }
    if (((token === import31.TemplateRef) && (27 === requestNodeIndex))) { return this._TemplateRef_27_5; }
    if (((token === import33.NgIf) && (27 === requestNodeIndex))) { return this._NgIf_27_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_11_0_0:any = this.context.loading;
    this._NgSwitch_11_3.check_ngSwitch(currVal_11_0_0,throwOnChange,false);
    this._NgSwitch_11_3.detectChangesInInputProps(this,this._el_11,throwOnChange);
    const currVal_20_0_0:any = true;
    this._NgSwitchCase_20_6.check_ngSwitchCase(currVal_20_0_0,throwOnChange,false);
    this._NgSwitchCase_20_6.detectChangesInInputProps(this,this._anchor_20,throwOnChange);
    const currVal_23_0_0:any = (this.context.content && this.context.currentLanguage);
    this._NgIf_23_6.check_ngIf(currVal_23_0_0,throwOnChange,false);
    this._NgIf_23_6.detectChangesInInputProps(this,this._anchor_23,throwOnChange);
    const currVal_27_0_0:any = (this.context.mltContents.length > 0);
    this._NgIf_27_6.check_ngIf(currVal_27_0_0,throwOnChange,false);
    this._NgIf_27_6.detectChangesInInputProps(this,this._anchor_27,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSwitch_11_3.detectChangesInHostProps(this,this._el_11,throwOnChange);
    valUnwrapper.reset();
    const currVal_39:any = import5.interpolate(1,'\n            ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_0,this._pipe_intl_0.transform)(((this.context.intl.data == (null as any))? (null as any): this.context.intl.data.COMMON.BACK),this.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_39,currVal_39))) {
      this.renderer.setText(this._text_16,currVal_39);
      this._expr_39 = currVal_39;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_15_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_15_0:any = ((<any>this.context.location.back()) !== false);
    return (true && pd_15_0);
  }
}
export function viewFactory_ContentRecordComponent0(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<import0.ContentRecordComponent> {
  if ((renderType_ContentRecordComponent === (null as any))) { (renderType_ContentRecordComponent = viewUtils.createRenderComponentType('',0,import20.ViewEncapsulation.None,styles_ContentRecordComponent,{})); }
  return new _View_ContentRecordComponent0(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent1 extends import1.AppView<any> {
  _el_0:any;
  /*private*/ _appEl_0:import3.AppElement;
  _LoadingIndicator_0_4:import34.Wrapper_LoadingIndicator;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent1,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'loading-indicator',new import5.InlineArray2(2,'color','#B6B6B6'),(null as any));
    this._appEl_0 = new import3.AppElement(0,(null as any),this,this._el_0);
    var compView_0:any = import34.viewFactory_LoadingIndicator0(this.viewUtils,this.injector(0),this._appEl_0);
    this._LoadingIndicator_0_4 = new import34.Wrapper_LoadingIndicator();
    this._appEl_0.initComponent(this._LoadingIndicator_0_4.context,([] as any[]),compView_0);
    compView_0.create(this._LoadingIndicator_0_4.context,([] as any[]),(null as any));
    this.init(([] as any[]).concat([this._el_0]),[this._el_0],([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import35.LoadingIndicator) && (0 === requestNodeIndex))) { return this._LoadingIndicator_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = '#B6B6B6';
    this._LoadingIndicator_0_4.check_color(currVal_0_0_0,throwOnChange,false);
    this._LoadingIndicator_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._LoadingIndicator_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent1(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent1(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _text_2:any;
  _el_3:any;
  _text_4:any;
  _el_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _el_11:any;
  _text_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _el_16:any;
  _text_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _text_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _text_33:any;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _text_39:any;
  _el_40:any;
  _text_41:any;
  _text_42:any;
  _text_43:any;
  _el_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _text_51:any;
  _el_52:any;
  _SelectControlValueAccessor_52_3:import36.Wrapper_SelectControlValueAccessor;
  _NG_VALUE_ACCESSOR_52_4:any[];
  _NgModel_52_5:import37.Wrapper_NgModel;
  _NgControl_52_6:any;
  _NgControlStatus_52_7:import38.Wrapper_NgControlStatus;
  _text_53:any;
  _anchor_54:any;
  /*private*/ _appEl_54:import3.AppElement;
  _TemplateRef_54_5:any;
  _NgFor_54_6:import39.Wrapper_NgFor;
  _text_55:any;
  _text_56:any;
  _text_57:any;
  _text_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _anchor_63:any;
  /*private*/ _appEl_63:import3.AppElement;
  _TemplateRef_63_5:any;
  _NgIf_63_6:import23.Wrapper_NgIf;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _appEl_65:import3.AppElement;
  _TemplateRef_65_5:any;
  _NgIf_65_6:import23.Wrapper_NgIf;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _text_69:any;
  _el_70:any;
  _text_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _text_75:any;
  _text_76:any;
  _el_77:any;
  _text_78:any;
  _text_79:any;
  _el_80:any;
  _text_81:any;
  _el_82:any;
  _text_83:any;
  _el_84:any;
  _text_85:any;
  _anchor_86:any;
  /*private*/ _appEl_86:import3.AppElement;
  _TemplateRef_86_5:any;
  _NgFor_86_6:import39.Wrapper_NgFor;
  _text_87:any;
  _text_88:any;
  _text_89:any;
  _text_90:any;
  _text_91:any;
  _text_92:any;
  _text_93:any;
  _text_94:any;
  _text_95:any;
  _text_96:any;
  _text_97:any;
  _text_98:any;
  _text_99:any;
  _anchor_100:any;
  /*private*/ _appEl_100:import3.AppElement;
  _TemplateRef_100_5:any;
  _NgIf_100_6:import23.Wrapper_NgIf;
  _text_101:any;
  _anchor_102:any;
  /*private*/ _appEl_102:import3.AppElement;
  _TemplateRef_102_5:any;
  _NgIf_102_6:import23.Wrapper_NgIf;
  _text_103:any;
  _el_104:any;
  _el_105:any;
  _text_106:any;
  _text_107:any;
  _text_108:any;
  _text_109:any;
  /*private*/ _expr_133:any;
  /*private*/ _expr_134:any;
  /*private*/ _expr_135:any;
  /*private*/ _expr_136:any;
  /*private*/ _expr_137:any;
  /*private*/ _expr_138:any;
  _pipe_replace_1_0:any;
  /*private*/ _expr_140:any;
  /*private*/ _expr_141:any;
  _pipe_numberFormat_2_0:any;
  _arr_143:any;
  /*private*/ _expr_144:any;
  _pipe_intl_0_5:any;
  /*private*/ _expr_146:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent2,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_133 = import8.UNINITIALIZED;
    this._expr_134 = import8.UNINITIALIZED;
    this._expr_135 = import8.UNINITIALIZED;
    this._expr_136 = import8.UNINITIALIZED;
    this._expr_137 = import8.UNINITIALIZED;
    this._expr_138 = import8.UNINITIALIZED;
    this._expr_140 = import8.UNINITIALIZED;
    this._expr_141 = import8.UNINITIALIZED;
    this._arr_143 = import5.pureProxy10((p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any):any[] => {
      return [
        p0,
        p1,
        p2,
        p3,
        p4,
        p5,
        p6,
        p7,
        p8,
        p9
      ]
      ;
    });
    this._expr_144 = import8.UNINITIALIZED;
    this._expr_146 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,' \n            ',(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_3 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','col-md-6 col-sm-12 record-zoom-gallery product-image sm-margin-bottom-ten'),(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'\n                ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_3,'a',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_5,'img',new import5.InlineArray4(4,'alt','','class','project-img-gallery'),(null as any));
    this._text_7 = this.renderer.createText(this._el_3,'\n                ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_3,'div',new import5.InlineArray2(2,'class',''),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import5.createRenderElement(this.renderer,this._el_8,'a',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_10,'img',new import5.InlineArray4(4,'alt','','class','project-img-gallery'),(null as any));
    this._text_12 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_13 = this.renderer.createText(this._el_3,' \n            ',(null as any));
    this._text_14 = this.renderer.createText(this._el_0,'\n            \n            ',(null as any));
    this._text_15 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._el_16 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','col-md-5 col-sm-12 col-md-offset-1'),(null as any));
    this._text_17 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_18 = this.renderer.createText(this._el_16,'\n\n                ',(null as any));
    this._el_19 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','rating margin-five'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                    ',(null as any));
    this._el_21 = import5.createRenderElement(this.renderer,this._el_19,'span',new import5.InlineArray2(2,'class','record-date rating-text text-uppercase'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'Ref: ',(null as any));
    this._el_23 = import5.createRenderElement(this.renderer,this._el_21,'span',new import5.InlineArray2(2,'class','black-text'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'',(null as any));
    this._text_25 = this.renderer.createText(this._el_19,'\n                    ',(null as any));
    this._el_26 = import5.createRenderElement(this.renderer,this._el_19,'span',new import5.InlineArray2(2,'class','rating-text text-uppercase pull-right'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'',(null as any));
    this._text_28 = this.renderer.createText(this._el_19,'\n                ',(null as any));
    this._text_29 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_30 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_31 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_32 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_33 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_34 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_36 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._el_37 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','separator-line bg-black no-margin-lr margin-five'),(null as any));
    this._text_38 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_39 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._el_40 = import5.createRenderElement(this.renderer,this._el_16,'p',new import5.InlineArray2(2,'class','text-uppercase letter-spacing-2'),(null as any));
    this._text_41 = this.renderer.createText(this._el_40,'',(null as any));
    this._text_42 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_43 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._el_44 = import5.createRenderElement(this.renderer,this._el_16,'span',new import5.InlineArray2(2,'class','price black-text title-small'),(null as any));
    this._text_45 = this.renderer.createText(this._el_44,'',(null as any));
    this._text_46 = this.renderer.createText(this._el_16,'\n\n                ',(null as any));
    this._el_47 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','col-md-3 col-sm-3 no-padding-left margin-five'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                    ',(null as any));
    this._el_49 = import5.createRenderElement(this.renderer,this._el_47,'div',new import5.InlineArray2(2,'class','select-style med-input xs-med-input shop-shorting-details no-border-round'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                        ',(null as any));
    this._text_51 = this.renderer.createText(this._el_49,'\n                        ',(null as any));
    this._el_52 = import5.createRenderElement(this.renderer,this._el_49,'select',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._SelectControlValueAccessor_52_3 = new import36.Wrapper_SelectControlValueAccessor(this.renderer,new import9.ElementRef(this._el_52));
    this._NG_VALUE_ACCESSOR_52_4 = [this._SelectControlValueAccessor_52_3.context];
    this._NgModel_52_5 = new import37.Wrapper_NgModel((null as any),(null as any),(null as any),this._NG_VALUE_ACCESSOR_52_4);
    this._NgControl_52_6 = this._NgModel_52_5.context;
    this._NgControlStatus_52_7 = new import38.Wrapper_NgControlStatus(this._NgControl_52_6);
    this._text_53 = this.renderer.createText(this._el_52,'\n                            ',(null as any));
    this._anchor_54 = this.renderer.createTemplateAnchor(this._el_52,(null as any));
    this._appEl_54 = new import3.AppElement(54,52,this,this._anchor_54);
    this._TemplateRef_54_5 = new import31.TemplateRef_(this._appEl_54,viewFactory_ContentRecordComponent3);
    this._NgFor_54_6 = new import39.Wrapper_NgFor(this._appEl_54.vcRef,this._TemplateRef_54_5,this.parent.parentInjector.get(import40.IterableDiffers),this.parent.ref);
    this._text_55 = this.renderer.createText(this._el_52,'\n                        ',(null as any));
    this._text_56 = this.renderer.createText(this._el_49,'\n                        ',(null as any));
    this._text_57 = this.renderer.createText(this._el_49,'\n                    ',(null as any));
    this._text_58 = this.renderer.createText(this._el_47,'\n                ',(null as any));
    this._text_59 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._el_60 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','col-md-9 col-sm-9 no-padding margin-five'),(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._text_62 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._anchor_63 = this.renderer.createTemplateAnchor(this._el_60,(null as any));
    this._appEl_63 = new import3.AppElement(63,60,this,this._anchor_63);
    this._TemplateRef_63_5 = new import31.TemplateRef_(this._appEl_63,viewFactory_ContentRecordComponent4);
    this._NgIf_63_6 = new import23.Wrapper_NgIf(this._appEl_63.vcRef,this._TemplateRef_63_5);
    this._text_64 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_60,(null as any));
    this._appEl_65 = new import3.AppElement(65,60,this,this._anchor_65);
    this._TemplateRef_65_5 = new import31.TemplateRef_(this._appEl_65,viewFactory_ContentRecordComponent5);
    this._NgIf_65_6 = new import23.Wrapper_NgIf(this._appEl_65.vcRef,this._TemplateRef_65_5);
    this._text_66 = this.renderer.createText(this._el_60,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_60,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_16,'\n                ',(null as any));
    this._text_69 = this.renderer.createText(this._el_16,'\n\n            ',(null as any));
    this._el_70 = import5.createRenderElement(this.renderer,this._el_16,'div',new import5.InlineArray2(2,'class','col-md-12 col-sm-12 no-padding-left margin-five'),(null as any));
    this._text_71 = this.renderer.createText(this._el_70,'\n                ',(null as any));
    this._text_72 = this.renderer.createText(this._el_70,'\n                ',(null as any));
    this._el_73 = import5.createRenderElement(this.renderer,this._el_70,'div',new import5.InlineArray2(2,'class','tab-style1'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'\n                    ',(null as any));
    this._text_75 = this.renderer.createText(this._el_73,'\n                    ',(null as any));
    this._text_76 = this.renderer.createText(this._el_73,'\n                    ',(null as any));
    this._el_77 = import5.createRenderElement(this.renderer,this._el_73,'div',new import5.InlineArray2(2,'class','tab-content'),(null as any));
    this._text_78 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._el_80 = import5.createRenderElement(this.renderer,this._el_77,'div',new import5.InlineArray4(4,'class','tab-pane fade in active','id','tab_details'),(null as any));
    this._text_81 = this.renderer.createText(this._el_80,'\n                            ',(null as any));
    this._el_82 = import5.createRenderElement(this.renderer,this._el_80,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_83 = this.renderer.createText(this._el_82,'\n                                ',(null as any));
    this._el_84 = import5.createRenderElement(this.renderer,this._el_82,'div',new import5.InlineArray2(2,'class','col-md-12 col-sm-12 review-main'),(null as any));
    this._text_85 = this.renderer.createText(this._el_84,'\n                                    ',(null as any));
    this._anchor_86 = this.renderer.createTemplateAnchor(this._el_84,(null as any));
    this._appEl_86 = new import3.AppElement(86,84,this,this._anchor_86);
    this._TemplateRef_86_5 = new import31.TemplateRef_(this._appEl_86,viewFactory_ContentRecordComponent6);
    this._NgFor_86_6 = new import39.Wrapper_NgFor(this._appEl_86.vcRef,this._TemplateRef_86_5,this.parent.parentInjector.get(import40.IterableDiffers),this.parent.ref);
    this._text_87 = this.renderer.createText(this._el_84,'\n                                ',(null as any));
    this._text_88 = this.renderer.createText(this._el_82,'\n                            ',(null as any));
    this._text_89 = this.renderer.createText(this._el_80,'\n                        ',(null as any));
    this._text_90 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._text_91 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._text_92 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._text_93 = this.renderer.createText(this._el_77,'\n                        ',(null as any));
    this._text_94 = this.renderer.createText(this._el_77,'\n                    ',(null as any));
    this._text_95 = this.renderer.createText(this._el_73,'\n                    ',(null as any));
    this._text_96 = this.renderer.createText(this._el_73,'\n                ',(null as any));
    this._text_97 = this.renderer.createText(this._el_70,'\n                ',(null as any));
    this._text_98 = this.renderer.createText(this._el_70,'\n            ',(null as any));
    this._text_99 = this.renderer.createText(this._el_16,'  \n            \n            ',(null as any));
    this._anchor_100 = this.renderer.createTemplateAnchor(this._el_16,(null as any));
    this._appEl_100 = new import3.AppElement(100,16,this,this._anchor_100);
    this._TemplateRef_100_5 = new import31.TemplateRef_(this._appEl_100,viewFactory_ContentRecordComponent12);
    this._NgIf_100_6 = new import23.Wrapper_NgIf(this._appEl_100.vcRef,this._TemplateRef_100_5);
    this._text_101 = this.renderer.createText(this._el_16,'\n  \n            ',(null as any));
    this._anchor_102 = this.renderer.createTemplateAnchor(this._el_16,(null as any));
    this._appEl_102 = new import3.AppElement(102,16,this,this._anchor_102);
    this._TemplateRef_102_5 = new import31.TemplateRef_(this._appEl_102,viewFactory_ContentRecordComponent13);
    this._NgIf_102_6 = new import23.Wrapper_NgIf(this._appEl_102.vcRef,this._TemplateRef_102_5);
    this._text_103 = this.renderer.createText(this._el_16,'\n            ',(null as any));
    this._el_104 = import5.createRenderElement(this.renderer,this._el_16,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_105 = import5.createRenderElement(this.renderer,this._el_104,'b',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_106 = this.renderer.createText(this._el_105,'',(null as any));
    this._text_107 = this.renderer.createText(this._el_104,'',(null as any));
    this._text_108 = this.renderer.createText(this._el_16,'\n            \n            ',(null as any));
    this._text_109 = this.renderer.createText(this._el_0,'\n\n\n\n        ',(null as any));
    this._pipe_replace_1_0 = import5.pureProxy3((<_View_ContentRecordComponent0>this.parent)._pipe_replace_1.transform.bind((<_View_ContentRecordComponent0>this.parent)._pipe_replace_1));
    this._pipe_numberFormat_2_0 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent)._pipe_numberFormat_2.transform.bind((<_View_ContentRecordComponent0>this.parent)._pipe_numberFormat_2));
    var disposable_0:Function = this.renderer.listen(this._el_52,'ngModelChange',this.eventHandler(this._handle_ngModelChange_52_0.bind(this)));
    var disposable_1:Function = this.renderer.listen(this._el_52,'change',this.eventHandler(this._handle_change_52_1.bind(this)));
    var disposable_2:Function = this.renderer.listen(this._el_52,'blur',this.eventHandler(this._handle_blur_52_2.bind(this)));
    const subscription_0:any = this._NgModel_52_5.context.update.subscribe(this.eventHandler(this._handle_ngModelChange_52_0.bind(this)));
    this._pipe_intl_0_5 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._text_2,
      this._el_3,
      this._text_4,
      this._el_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._el_11,
      this._text_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._text_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._text_33,
      this._text_34,
      this._text_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._text_39,
      this._el_40,
      this._text_41,
      this._text_42,
      this._text_43,
      this._el_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._text_51,
      this._el_52,
      this._text_53,
      this._anchor_54,
      this._text_55,
      this._text_56,
      this._text_57,
      this._text_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._anchor_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._text_69,
      this._el_70,
      this._text_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._text_75,
      this._text_76,
      this._el_77,
      this._text_78,
      this._text_79,
      this._el_80,
      this._text_81,
      this._el_82,
      this._text_83,
      this._el_84,
      this._text_85,
      this._anchor_86,
      this._text_87,
      this._text_88,
      this._text_89,
      this._text_90,
      this._text_91,
      this._text_92,
      this._text_93,
      this._text_94,
      this._text_95,
      this._text_96,
      this._text_97,
      this._text_98,
      this._text_99,
      this._anchor_100,
      this._text_101,
      this._anchor_102,
      this._text_103,
      this._el_104,
      this._el_105,
      this._text_106,
      this._text_107,
      this._text_108,
      this._text_109
    ]
    ,[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    ,[subscription_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (54 === requestNodeIndex))) { return this._TemplateRef_54_5; }
    if (((token === import41.NgFor) && (54 === requestNodeIndex))) { return this._NgFor_54_6.context; }
    if (((token === import42.SelectControlValueAccessor) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._SelectControlValueAccessor_52_3.context; }
    if (((token === import43.NG_VALUE_ACCESSOR) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._NG_VALUE_ACCESSOR_52_4; }
    if (((token === import44.NgModel) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._NgModel_52_5.context; }
    if (((token === import45.NgControl) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._NgControl_52_6; }
    if (((token === import46.NgControlStatus) && ((52 <= requestNodeIndex) && (requestNodeIndex <= 55)))) { return this._NgControlStatus_52_7.context; }
    if (((token === import31.TemplateRef) && (63 === requestNodeIndex))) { return this._TemplateRef_63_5; }
    if (((token === import33.NgIf) && (63 === requestNodeIndex))) { return this._NgIf_63_6.context; }
    if (((token === import31.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import33.NgIf) && (65 === requestNodeIndex))) { return this._NgIf_65_6.context; }
    if (((token === import31.TemplateRef) && (86 === requestNodeIndex))) { return this._TemplateRef_86_5; }
    if (((token === import41.NgFor) && (86 === requestNodeIndex))) { return this._NgFor_86_6.context; }
    if (((token === import31.TemplateRef) && (100 === requestNodeIndex))) { return this._TemplateRef_100_5; }
    if (((token === import33.NgIf) && (100 === requestNodeIndex))) { return this._NgIf_100_6.context; }
    if (((token === import31.TemplateRef) && (102 === requestNodeIndex))) { return this._TemplateRef_102_5; }
    if (((token === import33.NgIf) && (102 === requestNodeIndex))) { return this._NgIf_102_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this._SelectControlValueAccessor_52_3.detectChangesInInputProps(this,this._el_52,throwOnChange);
    const currVal_52_1_0:any = this.parent.context.qty;
    this._NgModel_52_5.check_model(currVal_52_1_0,throwOnChange,false);
    this._NgModel_52_5.detectChangesInInputProps(this,this._el_52,throwOnChange);
    this._NgControlStatus_52_7.detectChangesInInputProps(this,this._el_52,throwOnChange);
    const currVal_54_0_0:any = this._arr_143(1,2,3,4,5,6,7,8,9,10);
    this._NgFor_54_6.check_ngForOf(currVal_54_0_0,throwOnChange,false);
    this._NgFor_54_6.detectChangesInInputProps(this,this._anchor_54,throwOnChange);
    const currVal_63_0_0:boolean = !this.parent.context.cartService.isInCart(this.parent.context.content._id);
    this._NgIf_63_6.check_ngIf(currVal_63_0_0,throwOnChange,false);
    this._NgIf_63_6.detectChangesInInputProps(this,this._anchor_63,throwOnChange);
    const currVal_65_0_0:any = this.parent.context.cartService.isInCart(this.parent.context.content._id);
    this._NgIf_65_6.check_ngIf(currVal_65_0_0,throwOnChange,false);
    this._NgIf_65_6.detectChangesInInputProps(this,this._anchor_65,throwOnChange);
    const currVal_86_0_0:any = this.parent.context.content.music_pieces;
    this._NgFor_86_6.check_ngForOf(currVal_86_0_0,throwOnChange,false);
    this._NgFor_86_6.detectChangesInInputProps(this,this._anchor_86,throwOnChange);
    const currVal_100_0_0:any = this.parent.context.content.description[this.parent.context.currentLanguage];
    this._NgIf_100_6.check_ngIf(currVal_100_0_0,throwOnChange,false);
    this._NgIf_100_6.detectChangesInInputProps(this,this._anchor_100,throwOnChange);
    const currVal_102_0_0:any = ((this.parent.context.content.original_references && (this.parent.context.content.original_references.length > 0)) && (this.parent.context.content.original_references[0] != ''));
    this._NgIf_102_6.check_ngIf(currVal_102_0_0,throwOnChange,false);
    this._NgIf_102_6.detectChangesInInputProps(this,this._anchor_102,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_133:any = import5.interpolate(1,'/data/covers/',this.parent.context.content.cover.front,'');
    if (import5.checkBinding(throwOnChange,this._expr_133,currVal_133)) {
      this.renderer.setElementProperty(this._el_5,'href',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL,currVal_133));
      this._expr_133 = currVal_133;
    }
    const currVal_134:any = import5.interpolate(1,'/data/covers/',this.parent.context.content.cover.front,'');
    if (import5.checkBinding(throwOnChange,this._expr_134,currVal_134)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL,currVal_134));
      this._expr_134 = currVal_134;
    }
    const currVal_135:any = import5.interpolate(1,'/data/covers/',this.parent.context.content.cover.back,'');
    if (import5.checkBinding(throwOnChange,this._expr_135,currVal_135)) {
      this.renderer.setElementProperty(this._el_10,'href',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL,currVal_135));
      this._expr_135 = currVal_135;
    }
    const currVal_136:any = import5.interpolate(1,'/data/covers/',this.parent.context.content.cover.back,'');
    if (import5.checkBinding(throwOnChange,this._expr_136,currVal_136)) {
      this.renderer.setElementProperty(this._el_11,'src',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL,currVal_136));
      this._expr_136 = currVal_136;
    }
    const currVal_137:any = import5.interpolate(1,'',this.parent.context.content.reference,'');
    if (import5.checkBinding(throwOnChange,this._expr_137,currVal_137)) {
      this.renderer.setText(this._text_24,currVal_137);
      this._expr_137 = currVal_137;
    }
    valUnwrapper.reset();
    const currVal_138:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_replace_1_0,(<_View_ContentRecordComponent0>this.parent)._pipe_replace_1.transform)(this.parent.context.content.date,'T.+','')),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_138,currVal_138))) {
      this.renderer.setText(this._text_27,currVal_138);
      this._expr_138 = currVal_138;
    }
    const currVal_140:any = import5.interpolate(1,'',this.parent.context.content.title,'');
    if (import5.checkBinding(throwOnChange,this._expr_140,currVal_140)) {
      this.renderer.setText(this._text_41,currVal_140);
      this._expr_140 = currVal_140;
    }
    valUnwrapper.reset();
    const currVal_141:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_numberFormat_2_0,(<_View_ContentRecordComponent0>this.parent)._pipe_numberFormat_2.transform)(this.parent.context.content.price,2)),'€');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_141,currVal_141))) {
      this.renderer.setText(this._text_45,currVal_141);
      this._expr_141 = currVal_141;
    }
    this._SelectControlValueAccessor_52_3.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._NgModel_52_5.detectChangesInHostProps(this,this._el_52,throwOnChange);
    this._NgControlStatus_52_7.detectChangesInHostProps(this,this._el_52,throwOnChange);
    valUnwrapper.reset();
    const currVal_144:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_5,(<_View_ContentRecordComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.RECORD.LENGTH),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_144,currVal_144))) {
      this.renderer.setText(this._text_106,currVal_144);
      this._expr_144 = currVal_144;
    }
    const currVal_146:any = import5.interpolate(1,': ',this.parent.context.content.length,'');
    if (import5.checkBinding(throwOnChange,this._expr_146,currVal_146)) {
      this.renderer.setText(this._text_107,currVal_146);
      this._expr_146 = currVal_146;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgModel_52_5.context.ngOnDestroy();
  }
  private _handle_ngModelChange_52_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_52_0:any = ((<any>(this.parent.context.qty = $event)) !== false);
    return (true && pd_52_0);
  }
  private _handle_change_52_1($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_52_0:any = ((<any>this._SelectControlValueAccessor_52_3.context.onChange($event.target.value)) !== false);
    return (true && pd_52_0);
  }
  private _handle_blur_52_2($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_52_0:any = ((<any>this._SelectControlValueAccessor_52_3.context.onTouched()) !== false);
    return (true && pd_52_0);
  }
}
function viewFactory_ContentRecordComponent2(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent2(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent3 extends import1.AppView<any> {
  _el_0:any;
  _NgSelectOption_0_3:import36.Wrapper_NgSelectOption;
  _NgSelectMultipleOption_0_4:import48.Wrapper_NgSelectMultipleOption;
  _text_1:any;
  /*private*/ _expr_4:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent3,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'option',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._NgSelectOption_0_3 = new import36.Wrapper_NgSelectOption(new import9.ElementRef(this._el_0),this.renderer,(<_View_ContentRecordComponent2>this.parent)._SelectControlValueAccessor_52_3.context);
    this._NgSelectMultipleOption_0_4 = new import48.Wrapper_NgSelectMultipleOption(new import9.ElementRef(this._el_0),this.renderer,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import42.NgSelectOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectOption_0_3.context; }
    if (((token === import49.NgSelectMultipleOption) && ((0 <= requestNodeIndex) && (requestNodeIndex <= 1)))) { return this._NgSelectMultipleOption_0_4.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_0_0_0:any = this.context.$implicit;
    this._NgSelectOption_0_3.check_value(currVal_0_0_0,throwOnChange,false);
    this._NgSelectOption_0_3.detectChangesInInputProps(this,this._el_0,throwOnChange);
    const currVal_0_1_0:any = this.context.$implicit;
    this._NgSelectMultipleOption_0_4.check_value(currVal_0_1_0,throwOnChange,false);
    this._NgSelectMultipleOption_0_4.detectChangesInInputProps(this,this._el_0,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    this._NgSelectOption_0_3.detectChangesInHostProps(this,this._el_0,throwOnChange);
    this._NgSelectMultipleOption_0_4.detectChangesInHostProps(this,this._el_0,throwOnChange);
    const currVal_4:any = import5.interpolate(1,'',this.context.$implicit,'');
    if (import5.checkBinding(throwOnChange,this._expr_4,currVal_4)) {
      this.renderer.setText(this._text_1,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  destroyInternal():void {
    this._NgSelectOption_0_3.context.ngOnDestroy();
    this._NgSelectMultipleOption_0_4.context.ngOnDestroy();
  }
}
function viewFactory_ContentRecordComponent3(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent3(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent4 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_intl_0_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent4,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_3 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','highlight-button-dark btn btn-medium button pointer'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'i',new import5.InlineArray2(2,'class','icon-basket'),(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this._pipe_intl_0_1 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_3:any = import5.interpolate(1,' \n                        ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_1,(<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.ADD),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.addToCart(this.parent.parent.context.content,this.parent.parent.context.qty)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordComponent4(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent4(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent5 extends import1.AppView<any> {
  _el_0:any;
  _el_1:any;
  _text_2:any;
  /*private*/ _expr_3:any;
  _pipe_intl_0_2:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent5,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_3 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'a',new import5.InlineArray2(2,'class','btn btn-medium button pointer'),(null as any));
    this._el_1 = import5.createRenderElement(this.renderer,this._el_0,'i',new import5.InlineArray2(2,'class','fa fa-remove'),(null as any));
    this._text_2 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_0,'click',this.eventHandler(this._handle_click_0_0.bind(this)));
    this._pipe_intl_0_2 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._el_1,
      this._text_2
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_3:any = import5.interpolate(1,' \n                        ',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_2,(<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.CART.REMOVE),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_3,currVal_3))) {
      this.renderer.setText(this._text_2,currVal_3);
      this._expr_3 = currVal_3;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_0_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_0_0:any = ((<any>this.parent.parent.context.removeFromCart(this.parent.parent.context.content._id)) !== false);
    return (true && pd_0_0);
  }
}
function viewFactory_ContentRecordComponent5(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent5(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgFor_7_6:import39.Wrapper_NgFor;
  _text_8:any;
  _anchor_9:any;
  /*private*/ _appEl_9:import3.AppElement;
  _TemplateRef_9_5:any;
  _NgIf_9_6:import23.Wrapper_NgIf;
  _text_10:any;
  _anchor_11:any;
  /*private*/ _appEl_11:import3.AppElement;
  _TemplateRef_11_5:any;
  _NgIf_11_6:import23.Wrapper_NgIf;
  _text_12:any;
  /*private*/ _expr_22:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent6,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_22 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','review'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'p',new import5.InlineArray2(2,'class','letter-spacing-2 text-uppercase review-name'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                            ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'strong',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_7 = new import3.AppElement(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import31.TemplateRef_(this._appEl_7,viewFactory_ContentRecordComponent7);
    this._NgFor_7_6 = new import39.Wrapper_NgFor(this._appEl_7.vcRef,this._TemplateRef_7_5,this.parent.parent.parentInjector.get(import40.IterableDiffers),this.parent.parent.ref);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._anchor_9 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_9 = new import3.AppElement(9,0,this,this._anchor_9);
    this._TemplateRef_9_5 = new import31.TemplateRef_(this._appEl_9,viewFactory_ContentRecordComponent10);
    this._NgIf_9_6 = new import23.Wrapper_NgIf(this._appEl_9.vcRef,this._TemplateRef_9_5);
    this._text_10 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._anchor_11 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_11 = new import3.AppElement(11,0,this,this._anchor_11);
    this._TemplateRef_11_5 = new import31.TemplateRef_(this._appEl_11,viewFactory_ContentRecordComponent11);
    this._NgIf_11_6 = new import23.Wrapper_NgIf(this._appEl_11.vcRef,this._TemplateRef_11_5);
    this._text_12 = this.renderer.createText(this._el_0,'\n                                    ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._anchor_7,
      this._text_8,
      this._anchor_9,
      this._text_10,
      this._anchor_11,
      this._text_12
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import41.NgFor) && (7 === requestNodeIndex))) { return this._NgFor_7_6.context; }
    if (((token === import31.TemplateRef) && (9 === requestNodeIndex))) { return this._TemplateRef_9_5; }
    if (((token === import33.NgIf) && (9 === requestNodeIndex))) { return this._NgIf_9_6.context; }
    if (((token === import31.TemplateRef) && (11 === requestNodeIndex))) { return this._TemplateRef_11_5; }
    if (((token === import33.NgIf) && (11 === requestNodeIndex))) { return this._NgIf_11_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_7_0_0:any = this.context.$implicit.soloists;
    this._NgFor_7_6.check_ngForOf(currVal_7_0_0,throwOnChange,false);
    this._NgFor_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    const currVal_9_0_0:any = (this.context.$implicit.conductor && this.context.$implicit.orchestra);
    this._NgIf_9_6.check_ngIf(currVal_9_0_0,throwOnChange,false);
    this._NgIf_9_6.detectChangesInInputProps(this,this._anchor_9,throwOnChange);
    const currVal_11_0_0:any = this.context.$implicit.date;
    this._NgIf_11_6.check_ngIf(currVal_11_0_0,throwOnChange,false);
    this._NgIf_11_6.detectChangesInInputProps(this,this._anchor_11,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_22:any = import5.interpolate(2,'',this.context.$implicit.composer,', ',this.context.$implicit.title,'');
    if (import5.checkBinding(throwOnChange,this._expr_22,currVal_22)) {
      this.renderer.setText(this._text_5,currVal_22);
      this._expr_22 = currVal_22;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent6(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent6(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent7 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _anchor_5:any;
  /*private*/ _appEl_5:import3.AppElement;
  _TemplateRef_5_5:any;
  _NgIf_5_6:import23.Wrapper_NgIf;
  _text_6:any;
  _anchor_7:any;
  /*private*/ _appEl_7:import3.AppElement;
  _TemplateRef_7_5:any;
  _NgIf_7_6:import23.Wrapper_NgIf;
  _text_8:any;
  /*private*/ _expr_15:any;
  _pipe_nameResolver_3_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent7,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_15 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','reclink pointer'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,' ',(null as any));
    this._anchor_5 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_5 = new import3.AppElement(5,0,this,this._anchor_5);
    this._TemplateRef_5_5 = new import31.TemplateRef_(this._appEl_5,viewFactory_ContentRecordComponent8);
    this._NgIf_5_6 = new import23.Wrapper_NgIf(this._appEl_5.vcRef,this._TemplateRef_5_5);
    this._text_6 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._anchor_7 = this.renderer.createTemplateAnchor(this._el_0,(null as any));
    this._appEl_7 = new import3.AppElement(7,0,this,this._anchor_7);
    this._TemplateRef_7_5 = new import31.TemplateRef_(this._appEl_7,viewFactory_ContentRecordComponent9);
    this._NgIf_7_6 = new import23.Wrapper_NgIf(this._appEl_7.vcRef,this._TemplateRef_7_5);
    this._text_8 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this._pipe_nameResolver_3_0 = import5.pureProxy1((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3.transform.bind((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._anchor_5,
      this._text_6,
      this._anchor_7,
      this._text_8
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (5 === requestNodeIndex))) { return this._TemplateRef_5_5; }
    if (((token === import33.NgIf) && (5 === requestNodeIndex))) { return this._NgIf_5_6.context; }
    if (((token === import31.TemplateRef) && (7 === requestNodeIndex))) { return this._TemplateRef_7_5; }
    if (((token === import33.NgIf) && (7 === requestNodeIndex))) { return this._NgIf_7_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_5_0_0:any = this.context.$implicit.instrument;
    this._NgIf_5_6.check_ngIf(currVal_5_0_0,throwOnChange,false);
    this._NgIf_5_6.detectChangesInInputProps(this,this._anchor_5,throwOnChange);
    const currVal_7_0_0:any = (this.context.index < (this.parent.context.$implicit.soloists.length - 1));
    this._NgIf_7_6.check_ngIf(currVal_7_0_0,throwOnChange,false);
    this._NgIf_7_6.detectChangesInInputProps(this,this._anchor_7,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_15:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_nameResolver_3_0,(<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3.transform)(this.context.$implicit.name)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_15,currVal_15))) {
      this.renderer.setText(this._text_3,currVal_15);
      this._expr_15 = currVal_15;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(('catalogue?f=soloist~' + this.context.$implicit.name),this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_ContentRecordComponent7(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent7(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent8 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent8,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_2 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_2:any = import5.interpolate(1,'(',this.parent.context.$implicit.instrument,')');
    if (import5.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent8(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent8(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent9 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent9,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'span',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,', ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
}
function viewFactory_ContentRecordComponent9(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent9(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent10 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  /*private*/ _expr_5:any;
  _pipe_nameResolver_3_1:any;
  /*private*/ _expr_7:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent10,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_5 = import8.UNINITIALIZED;
    this._expr_7 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                            ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'a',new import5.InlineArray2(2,'class','reclink pointer'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_4 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_2,'click',this.eventHandler(this._handle_click_2_0.bind(this)));
    this._pipe_nameResolver_3_1 = import5.pureProxy1((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3.transform.bind((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_5:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_nameResolver_3_1,(<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_nameResolver_3.transform)(this.parent.context.$implicit.conductor)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_5,currVal_5))) {
      this.renderer.setText(this._text_3,currVal_5);
      this._expr_5 = currVal_5;
    }
    const currVal_7:any = import5.interpolate(1,' / ',this.parent.context.$implicit.orchestra,'\n                                        ');
    if (import5.checkBinding(throwOnChange,this._expr_7,currVal_7)) {
      this.renderer.setText(this._text_4,currVal_7);
      this._expr_7 = currVal_7;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_2_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_2_0:any = ((<any>this.parent.parent.parent.context.utils.lLink(('catalogue?f=conductor~' + this.parent.context.$implicit.conductor),this.parent.parent.parent.context.currentLanguage)) !== false);
    return (true && pd_2_0);
  }
}
function viewFactory_ContentRecordComponent10(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent10(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent11 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  /*private*/ _expr_4:any;
  _pipe_intl_0_3:any;
  _pipe_toYear_4_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent11,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_4 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','black-text letter-spacing-2'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                                        ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'',(null as any));
    this._pipe_intl_0_3 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_intl_0));
    this._pipe_toYear_4_0 = import5.pureProxy1((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_toYear_4.transform.bind((<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_toYear_4));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_4:any = import5.interpolate(2,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_3,(<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.parent.context.intl.data.RECORD.RECORDING),this.parent.parent.parent.context.currentLanguage)),': ',valUnwrapper.unwrap(import5.castByValue(this._pipe_toYear_4_0,(<_View_ContentRecordComponent0>this.parent.parent.parent)._pipe_toYear_4.transform)(this.parent.context.$implicit.date)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_4,currVal_4))) {
      this.renderer.setText(this._text_3,currVal_4);
      this._expr_4 = currVal_4;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent11(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent11(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent12 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _text_4:any;
  _el_5:any;
  _text_6:any;
  _text_7:any;
  /*private*/ _expr_8:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent12,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_8 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','record-description col-md-12'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._text_4 = this.renderer.createText(this._el_2,'\n                        ',(null as any));
    this._el_5 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','col-md-12 sm-margin-top-seven'),(null as any));
    this._text_6 = this.renderer.createText(this._el_2,'\n                    ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._text_4,
      this._el_5,
      this._text_6,
      this._text_7
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_8:any = this.parent.parent.context.utils.formatInHtml(this.parent.parent.context.content.description[this.parent.parent.context.currentLanguage],'p');
    if (import5.checkBinding(throwOnChange,this._expr_8,currVal_8)) {
      this.renderer.setElementProperty(this._el_5,'innerHTML',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.HTML,currVal_8));
      this._expr_8 = currVal_8;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent12(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent12(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent13 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _el_3:any;
  _text_4:any;
  _text_5:any;
  _text_6:any;
  /*private*/ _expr_7:any;
  _pipe_intl_0_4:any;
  /*private*/ _expr_9:any;
  _pipe_join_5_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent13,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_7 = import8.UNINITIALIZED;
    this._expr_9 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','record-original-references'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'small',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._el_3 = import5.createRenderElement(this.renderer,this._el_2,'b',import5.EMPTY_INLINE_ARRAY,(null as any));
    this._text_4 = this.renderer.createText(this._el_3,'',(null as any));
    this._text_5 = this.renderer.createText(this._el_2,'',(null as any));
    this._text_6 = this.renderer.createText(this._el_0,'\n            ',(null as any));
    this._pipe_intl_0_4 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0));
    this._pipe_join_5_0 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent)._pipe_join_5.transform.bind((<_View_ContentRecordComponent0>this.parent.parent)._pipe_join_5));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._el_3,
      this._text_4,
      this._text_5,
      this._text_6
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_7:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_4,(<_View_ContentRecordComponent0>this.parent.parent)._pipe_intl_0.transform)(((this.parent.parent.context.intl.data == (null as any))? (null as any): this.parent.parent.context.intl.data.RECORD.ORIGINAL_REFERENCES),this.parent.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_7,currVal_7))) {
      this.renderer.setText(this._text_4,currVal_7);
      this._expr_7 = currVal_7;
    }
    valUnwrapper.reset();
    const currVal_9:any = import5.interpolate(1,': ',valUnwrapper.unwrap(import5.castByValue(this._pipe_join_5_0,(<_View_ContentRecordComponent0>this.parent.parent)._pipe_join_5.transform)(this.parent.parent.context.content.original_references,', ')),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_9,currVal_9))) {
      this.renderer.setText(this._text_5,currVal_9);
      this._expr_9 = currVal_9;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent13(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent13(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent14 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _text_10:any;
  _text_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _anchor_15:any;
  /*private*/ _appEl_15:import3.AppElement;
  _TemplateRef_15_5:any;
  _NgFor_15_6:import39.Wrapper_NgFor;
  _text_16:any;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  /*private*/ _expr_23:any;
  _pipe_intl_0_6:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent14,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_23 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'section',new import5.InlineArray2(2,'class','border-top section-pull-up-less'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','container'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','row'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'div',new import5.InlineArray2(2,'class','col-md-12 text-center'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import5.createRenderElement(this.renderer,this._el_6,'h3',new import5.InlineArray2(2,'class','section-title'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'',(null as any));
    this._text_10 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_11 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_12 = this.renderer.createText(this._el_2,' \n        ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_2,'div',new import5.InlineArray2(2,'class','row record-listing-featured record-listing'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'\n          ',(null as any));
    this._anchor_15 = this.renderer.createTemplateAnchor(this._el_13,(null as any));
    this._appEl_15 = new import3.AppElement(15,13,this,this._anchor_15);
    this._TemplateRef_15_5 = new import31.TemplateRef_(this._appEl_15,viewFactory_ContentRecordComponent15);
    this._NgFor_15_6 = new import39.Wrapper_NgFor(this._appEl_15.vcRef,this._TemplateRef_15_5,this.parentInjector.get(import40.IterableDiffers),this.parent.ref);
    this._text_16 = this.renderer.createText(this._el_13,'\n        ',(null as any));
    this._text_17 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._text_18 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_19 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._pipe_intl_0_6 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent)._pipe_intl_0.transform.bind((<_View_ContentRecordComponent0>this.parent)._pipe_intl_0));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._text_10,
      this._text_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._anchor_15,
      this._text_16,
      this._text_17,
      this._text_18,
      this._text_19
    ]
    ,([] as any[]),([] as any[]));
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import31.TemplateRef) && (15 === requestNodeIndex))) { return this._TemplateRef_15_5; }
    if (((token === import41.NgFor) && (15 === requestNodeIndex))) { return this._NgFor_15_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    const currVal_15_0_0:any = this.parent.context.mltContents;
    this._NgFor_15_6.check_ngForOf(currVal_15_0_0,throwOnChange,false);
    this._NgFor_15_6.detectChangesInInputProps(this,this._anchor_15,throwOnChange);
    this.detectContentChildrenChanges(throwOnChange);
    valUnwrapper.reset();
    const currVal_23:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_intl_0_6,(<_View_ContentRecordComponent0>this.parent)._pipe_intl_0.transform)(((this.parent.context.intl.data == (null as any))? (null as any): this.parent.context.intl.data.RECORD.RECOMMENDATION),this.parent.context.currentLanguage)),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_23,currVal_23))) {
      this.renderer.setText(this._text_9,currVal_23);
      this._expr_23 = currVal_23;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
}
function viewFactory_ContentRecordComponent14(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent14(viewUtils,parentInjector,declarationEl);
}
class _View_ContentRecordComponent15 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _text_8:any;
  _text_9:any;
  _text_10:any;
  _el_11:any;
  _text_12:any;
  _el_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  /*private*/ _expr_17:any;
  /*private*/ _expr_18:any;
  _pipe_truncate_6_0:any;
  constructor(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement) {
    super(_View_ContentRecordComponent15,renderType_ContentRecordComponent,import7.ViewType.EMBEDDED,viewUtils,parentInjector,declarationEl,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_17 = import8.UNINITIALIZED;
    this._expr_18 = import8.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import3.AppElement {
    this._el_0 = import5.createRenderElement(this.renderer,(null as any),'div',new import5.InlineArray2(2,'class','col-md-3 col-xs-6 record-item'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_2 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class',''),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                  ',(null as any));
    this._el_4 = import5.createRenderElement(this.renderer,this._el_2,'a',new import5.InlineArray2(2,'class','pointer'),(null as any));
    this._text_5 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._el_6 = import5.createRenderElement(this.renderer,this._el_4,'img',new import5.InlineArray2(2,'alt',''),(null as any));
    this._text_7 = this.renderer.createText(this._el_4,'\n                    ',(null as any));
    this._text_8 = this.renderer.createText(this._el_4,'\n                  ',(null as any));
    this._text_9 = this.renderer.createText(this._el_2,'\n                ',(null as any));
    this._text_10 = this.renderer.createText(this._el_0,'\n                ',(null as any));
    this._el_11 = import5.createRenderElement(this.renderer,this._el_0,'div',new import5.InlineArray2(2,'class','record-desc'),(null as any));
    this._text_12 = this.renderer.createText(this._el_11,'\n                  ',(null as any));
    this._el_13 = import5.createRenderElement(this.renderer,this._el_11,'div',new import5.InlineArray2(2,'class','catalogue-record-title gray-text text-uppercase letter-spacing-2'),(null as any));
    this._text_14 = this.renderer.createText(this._el_13,'',(null as any));
    this._text_15 = this.renderer.createText(this._el_11,'\n                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_0,'\n          ',(null as any));
    var disposable_0:Function = this.renderer.listen(this._el_4,'click',this.eventHandler(this._handle_click_4_0.bind(this)));
    this._pipe_truncate_6_0 = import5.pureProxy2((<_View_ContentRecordComponent0>this.parent.parent)._pipe_truncate_6.transform.bind((<_View_ContentRecordComponent0>this.parent.parent)._pipe_truncate_6));
    this.init(([] as any[]).concat([this._el_0]),[
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._text_8,
      this._text_9,
      this._text_10,
      this._el_11,
      this._text_12,
      this._el_13,
      this._text_14,
      this._text_15,
      this._text_16
    ]
    ,[disposable_0],([] as any[]));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import8.ValueUnwrapper();
    this.detectContentChildrenChanges(throwOnChange);
    const currVal_17:any = import5.interpolate(1,'/data/covers/',this.context.$implicit.cover.front,'');
    if (import5.checkBinding(throwOnChange,this._expr_17,currVal_17)) {
      this.renderer.setElementProperty(this._el_6,'src',this.viewUtils.sanitizer.sanitize(import47.SecurityContext.URL,currVal_17));
      this._expr_17 = currVal_17;
    }
    valUnwrapper.reset();
    const currVal_18:any = import5.interpolate(1,'',valUnwrapper.unwrap(import5.castByValue(this._pipe_truncate_6_0,(<_View_ContentRecordComponent0>this.parent.parent)._pipe_truncate_6.transform)(this.context.$implicit.title,'75')),'');
    if ((valUnwrapper.hasWrappedValue || import5.checkBinding(throwOnChange,this._expr_18,currVal_18))) {
      this.renderer.setText(this._text_14,currVal_18);
      this._expr_18 = currVal_18;
    }
    this.detectViewChildrenChanges(throwOnChange);
  }
  private _handle_click_4_0($event:any):boolean {
    this.markPathToRootAsCheckOnce();
    const pd_4_0:any = ((<any>this.parent.parent.context.router.navigate([this.context.$implicit.url],{relativeTo: this.parent.parent.context.route.parent})) !== false);
    return (true && pd_4_0);
  }
}
function viewFactory_ContentRecordComponent15(viewUtils:import5.ViewUtils,parentInjector:import6.Injector,declarationEl:import3.AppElement):import1.AppView<any> {
  return new _View_ContentRecordComponent15(viewUtils,parentInjector,declarationEl);
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/front/content-record.component.ngfactory.ts